import TrackPlayer from 'react-native-track-player';
export const getTrackIdAndPosition = async () => {
    const [rawProgress, track,] = await Promise.all([
        TrackPlayer.getProgress(),
        TrackPlayer.getActiveTrack(),
    ]);
    const { position: rawPosition } = rawProgress || {};
    const rawPositionExists = rawPosition === undefined || rawPosition === null;
    if (rawPositionExists) {
        return null;
    }
    if (track === undefined) {
        return null;
    }
    const position = Math.floor(rawPosition);
    return {
        id: track.id,
        position,
    };
};
//# sourceMappingURL=getTrackIdAndPosition.js.map